import React from 'react';
import { useEffect } from 'react';
import { logInfo } from '../utils/debug';

const NotFoundPage = () => {
  useEffect(() => {
    logInfo('NotFoundPage loaded');
  }, []);

  return (
    
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>404 - Page Not Found</h2>
      <p>Sorry, the page you're looking for doesn’t exist.</p>
    </div>
  );
};

export default NotFoundPage;

